import { Component, Input } from '@angular/core';
@Component({
    selector: 'app-pore-pressure',
    template: `
      <app-pore-and-frac [pressureType]="'porePressure'" [componentId]="componentId"></app-pore-and-frac>
    `,
    standalone: false
})
export class PorePressureComponent {
  @Input()
  public componentId: string;
}
